import { render, staticRenderFns } from "./DonoutSemaforoKams.vue?vue&type=template&id=3936b7d2"
import script from "./DonoutSemaforoKams.vue?vue&type=script&lang=js"
export * from "./DonoutSemaforoKams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports